export enum Params {
  MaxActivePhonesCount = 'maxActivePhonesCount',
  MaxActiveEmailsCount = 'maxActiveEmailsCount',
  MaxActiveAddressesCount = 'maxActiveAddressesCount',
  SpecialOfferSubject = 'specialOfferSubject',
  SpecialOfferDescription = 'specialOfferDescription',
  MinCallBackTime = 'minCallBackTime',
  MaxCallBackTime = 'maxCallBackTime',
  MaxCallBackDays = 'maxCallBackDays',
}
